import { dataUriToBlob } from "../common/utils";
import { invokeApi, invokeApig, invokeLoggedInApi } from "../common/aws_lib";
import { config } from "../config";

const onApiError = e => {
  const msg = e.message.replace(/^.*:/, "");
  throw e;
};

const onApiSuccess = res => {
  if (res.errors) {
    console.log(res.errors);
    throw { message: "Internal server error" };
  }
  return res.data;
};

export const GetGallery = () =>
  invokeApi({
    method: "GET",
    path: `/query?query=${encodeURIComponent(
      "{searchGallery(noLimit:true, isPrivate:false){Items {photoId, photoName, photoAlt, photoKey, photoNum, thumbnail, photoWeb, photoFull, categories, subcategories, tags, isPrivate, ctaUrl}, LastEvaluatedKey{photoId}, Count}}"
    )}`,
    // headers: { "Cache-Control": "no-cache, no-store" }
  }).then(onApiSuccess, onApiError);

export const GetUntagged = () =>
  invokeApi({
    method: "GET",
    path: `/query?query=${encodeURIComponent(
      "{searchGallery(noLimit:true){Items {photoId, photoName, photoAlt, photoKey, photoNum, thumbnail, photoWeb, photoFull, categories, subcategories, tags, isPrivate, ctaUrl}, LastEvaluatedKey{photoId}, Count}}"
    )}`,
    // headers: { "Cache-Control": "no-cache, no-store" }
  }).then(onApiSuccess, onApiError);

export const GetGalleryPhoto = photoId =>
  invokeApi({
    method: "GET",
    path: `/query?query=${encodeURIComponent(
      `{gallery(photoId: "${photoId}"){photoId, photoName, photoAlt, photoKey, photoNum, thumbnail, photoWeb, photoFull, categories, subcategories, tags, isPrivate, ctaUrl}}`
    )}`,
    // headers: { "Cache-Control": "no-cache, no-store" }
  }).then(onApiSuccess, onApiError);

export const GetCategories = () =>
  invokeApi({
    method: "GET",
    path: `/query?query=${encodeURIComponent(
      "{categories{categoryName, subcategories}}"
    )}`,
    // headers: { "Cache-Control": "no-cache, no-store" }
  }).then(onApiSuccess, onApiError);

export const GetSettings = () =>
  invokeApi({
    method: "GET",
    path: `/query?query=${encodeURIComponent("{settings{ctaText}}")}`,
    // headers: { "Cache-Control": "no-cache, no-store" }
  }).then(onApiSuccess, onApiError);

export const UpdatePhoto = (
  photoId,
  photoName,
  photoNum,
  categories,
  subcategories,
  tags,
  isPrivate,
  photoWeb,
  thumbnail,
  photoFull,
  photoAlt,
  ctaUrl
) => {
  const input = `{
    photoName: "${photoName}",
    photoAlt: "${photoAlt || ""}",
    photoNum: ${photoNum},
    categories:  ${JSON.stringify(categories)}
    subcategories:  ${JSON.stringify(subcategories)}
    tags: ${JSON.stringify(tags)}
    isPrivate: ${isPrivate},
    photoFull: "${photoFull}",
    photoWeb: "${photoWeb}",
    thumbnail: "${thumbnail}",
    ctaUrl: "${ctaUrl || ""}",
  }`;
  return invokeApig({
    method: "POST",
    path: "/manage",
    headers: { "Content-Type": "application/json" },
    body: {
      data: `${`mutation{updatePhoto(photoId:"${photoId}", input:${input}){photoId}}`}`
    }
  }).then(onApiSuccess, onApiError);
};

export const UpdatePhotoMulti = (
  photoIds,
  categories,
  subcategories,
  tags,
  photoAlt
) => {
  const input = `{
    photoAlt: "${photoAlt || ""}",
    categories:  ${JSON.stringify(categories)}
    subcategories:  ${JSON.stringify(subcategories)}
    tags: ${JSON.stringify(tags)}
  }`;
  return invokeApig({
    method: "POST",
    path: "/manage",
    headers: { "Content-Type": "application/json" },
    body: {
      data: `${`mutation{updatePhotoMulti(photoIds:${JSON.stringify(
        photoIds
      )}, input:${input}){photoId}}`}`
    }
  }).then(onApiSuccess, onApiError);
};

export const AddPhoto = (photoKey, files, isPrivate, filename, tags) => {
  const input = `{
    photoName: "${filename}",
    photoAlt: "",
    categories: ${JSON.stringify([])},
    subcategories: ${JSON.stringify([])},
    photoKey: "${photoKey}",
    photoFull: "${files.photoFull}",
    photoWeb: "${files.photoWeb}",
    thumbnail: "${files.thumbnail}",
    fileType: "${files.fileType}",
    fileExt: "${files.fileExt}",
    tags: ${JSON.stringify(tags)}
    isPrivate: ${isPrivate},
    ctaUrl: "",
  }`;
  return invokeApig({
    method: "POST",
    path: "/manage",
    body: { data: `${`mutation{putPhoto(input:${input}){photoId}}`}` },
    headers: { "Content-Type": "application/json" }
  }).then(onApiSuccess, onApiError);
};

export const DeletePhoto = photoId =>
  invokeApig({
    method: "POST",
    path: "/manage",
    body: { data: `${`mutation{deletePhoto(photoId:"${photoId}"){photoId}}`}` },
    headers: { "Content-Type": "application/json" }
  }).then(onApiSuccess, onApiError);

export const DeletePhotoMulti = photoIds =>
  invokeApig({
    method: "POST",
    path: "/manage",
    body: {
      data: `${`mutation{deletePhotoMulti(photoIds:${JSON.stringify(
        photoIds
      )}){photoId}}`}`
    },
    headers: { "Content-Type": "application/json" }
  }).then(onApiSuccess, onApiError);

export const AddCategory = (categoryName, subcategories) => {
  const input = `{
      categoryName: "${categoryName}",
      subcategories: ${JSON.stringify(subcategories)}
    }`;
  return invokeApig({
    method: "POST",
    path: "/manage",
    body: { data: `${`mutation{putCategory(input:${input}){categoryName}}`}` },
    headers: { "Content-Type": "application/json" }
  }).then(onApiSuccess, onApiError);
};

export const DeleteCategory = categoryName =>
  invokeApig({
    method: "POST",
    path: "/manage",
    body: {
      data: `${`mutation{deleteCategory(categoryName:"${categoryName}"){categoryName}}`}`
    },
    headers: { "Content-Type": "application/json" }
  }).then(onApiSuccess, onApiError);

export const UpdateSettings = ctaText => {
  const input = `{
      ctaText: "${ctaText}"
    }`;
  return invokeApig({
    method: "POST",
    path: "/manage",
    headers: { "Content-Type": "application/json" },
    body: { data: `${`mutation{updateSettings(input:${input}){ctaText}}`}` }
  }).then(onApiSuccess, onApiError);
};

export const GetSitemap = () =>
  invokeApi({
    method: "GET",
    path: `/sitemap?rooturl=${config().rooturl}`,
    headers: { "Content-Type": "application/xml" }
  }).then(onApiSuccess, onApiError);

export const Hello = () =>
  invokeApig({
    method: "POST",
    path: "/hello",
    body: { data: "string" },
    headers: { "Content-Type": "application/json" }
  }).then(onApiSuccess, onApiError);

//request for upload file in aws s3
export const RequestUploadFile = (key, filetype) =>
  invokeApig({
    method: "POST",
    path: "/manage",
    body: {
      data: `${`mutation{uploadFile(key:"${key}",filetype:"${filetype}"){url}}`}`
    },
    headers: {
      "Content-Type": "application/json"
    }
  }).then(onApiSuccess, onApiError);

//upload file in aws s3
export const UploadFile = (url, file, filetype) =>
  fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": filetype,
      "x-amz-acl": "public-read",
      "CacheControl": 'max-age=2592000'
    },
    body: file
  }).then(onApiSuccess, onApiError);
